// SQL datetime2 timestamps are stored in UTC but may arrive without a timezone suffix.
export function findingDate(value) {
  if (!value) return null;
  const text = String(value);
  const date = new Date(/(?:Z|[+-]\d{2}:\d{2})$/i.test(text) ? text : `${text}Z`);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function findingDateInput(value) {
  const date = findingDate(value);
  if (!date) return '';
  const pad = n => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function findingDatePayload(input, original = null) {
  if (!input) return null;
  // An unchanged input must not round away the original seconds/milliseconds.
  if (original && input === findingDateInput(original)) return findingDate(original).toISOString();
  return new Date(input).toISOString();
}
